import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { ProyectosestrategicosService } from '../../../services/formulacion/proyectos-estrategicos/proyectosestrategicos.service';
import { Perspectiva, Objetivos, Adicionales, obtenerError, Responsables, Proyectos, Actividades, Meses, procesamiento } from '../../../models/Formulacion/indicadores-metas/datos';
import { messages } from '../../funciones/mensajes';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ExcelService } from '../../../services/excel/excel.service';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { StrategiaService } from '../../../services/gestion/strategias/strategia.service';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';
import { AdicionalService } from '../../../services/gestion/adicional/adicional.service';
import { ActividadService } from '../../../services/gestion/actividad/actividad.service';
import { PERMISOS } from '../../../shared/catalogos';
import { FiltersM } from '../../../components/models';

@Component({
  selector: 'app-proyectos-estrategicos',
  templateUrl: './proyectos-estrategicos.component.html',
  styleUrl: './proyectos-estrategicos.component.css'
})
export class ProyectosEstrategicosComponent {
  public readonly permisos = PERMISOS;

  /** Variables de filtros */
  Filters = FiltersM;

  public aniosDisponibles = [ {name: '2022', check: true}, {name: '2023', check: false},]
  public meses = [];
  public idPlanificacion :any;
  desactivado = false;
  skeleton = ['','','','','','','','','']
  minDate: any;
  maxDate: any;
  fechaAct : any;
  private diasLab: any;
  public perspectivas: Perspectiva[] = [];
  public objetivos: Objetivos[] = [];
  public estrategias: any[] = [];
  public responsables = [];
  public responsables2: Responsables[] =[];
  public responsablesAct: Responsables[] =[];
  public proyectos = [];
  public mostabla = false;
  public checks = [{check: false}];
  public actividades = [];
  public proyectosTot = [];
  public perSelect: any = '';
  public ObjecSelect: any;
  public objSelect: any = '';
  public estSelect: any = '';
  public selecAll = true;
  public selecAllAct = true;
  public ordenamiento = 'id';
  public expandirProg = false;
  public modal = false;
  public actEdit: any;
  public proyectoId: any;
  public proEdit: any;
  // **** Variables para el formateo de numeros
  public separador:string =  ","; // separador para los miles
  public sepDecimal:string = '.'; // separador para los decimales
  public titModal = '';
  public accionModal = '';
  private adicionalesPost = 0;
  public diccionarioAdicionales: any = [];
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  ngOnInit(){
    this.fechaAct = moment().format("YYYY-MM-DD");
  }
  formPro = new FormGroup({ 
    inputNamePro: new FormControl('', [Validators.required]),
    inputDescripcion: new FormControl(''),
    inputEstrategia: new FormControl(''),
    inputObjetivo: new FormControl('', [Validators.required]),
    inputLider: new FormControl('', [Validators.required]),    
  });
  formAct = new FormGroup({
    inputNameAct: new FormControl('', [Validators.required]),
    inputFechaIn: new FormControl('', [Validators.required]),
    inputFechaFn: new FormControl('', [Validators.required]),
    inputLider: new FormControl('', [Validators.required]),
  });
  formActRes = {
    inputNameAct: '',
    inputFechaIn: '',
    inputFechaFn: '',
    inputLider: '',
  }
  formProRes = {
    inputNamePro: '',
    inputDescripcion: '',
    inputEstrategia: '',
    inputObjetivo: '',
    inputLider: '',
  }
  formAdi = new FormGroup({ 
    inputNameAdi: new FormControl('', [Validators.required]),
    inputNameAdiEdit: new FormControl('', [Validators.required]),
  });
  formAdiRes = {
    inputNameAdi: '',
    inputNameAdiEdit: '',
  }

  modal1 = false;
  modal2 = false;
  modal3 = false;
  
  constructor(
    public dataService: DataService,
    private cookies: CookieService,
    // private proyextosestrategicoService: ProyectosestrategicosService,
    private excelService: ExcelService,
    private translate: TranslateService,

    private readonly planificacionService: PlanificacionService,
    private readonly responsableService: ResponsableService,
    private readonly objetivosService: ObjetivoService,
    private readonly strategiaService: StrategiaService,
    private readonly proyectosService: ProyectosService,
    private readonly actividadService: ActividadService,
    private readonly adicionalService: AdicionalService
  ) { 
    moment.updateLocale('en',{
        months: [
          "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
          "Septiembre","Octubre","Noviembre","Diciembre"
        ],
        monthsShort: [
          "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
          "Sep","Oct","Nov","Dic"
        ]
    });
    this.idPlanificacion = Number(cookies.get('idInstitucion'));
    this.obtData();
  }
  /** Obtención de los datos */
  private async obtData(){
    this.desactivado = true;
    try{
      const plan = await this.planificacionService.getPlanificacionByIdGQL(Number(this.idPlanificacion));
      const fechaini = moment(plan.initial_date.split('T')[0]);
      const fechafin = moment(plan.end_date.split('T')[0]);

      this.minDate = fechaini.format('YYYY-MM-DD');
      this.maxDate = fechafin.format('YYYY-MM-DD');
      this.diasLab = plan.business_days;
      const filters = {
        'Lunes-Viernes': (d: Date | null): boolean => {
          const day = (d || new Date()).getDay();
          return day !== 0 && day !== 6;
        },
        'Lunes-Sabado': (d: Date | null): boolean => {
          const day = (d || new Date()).getDay();
          return day !== 0;
        },
        'Lunes-Domingo': (): boolean => true,
      };
      
      this.myFilter = filters[plan.business_days] || (() => true);
      this.aniosDisponibles = [];

      while( fechaini.isSameOrBefore(fechafin, 'year') ){        
        this.aniosDisponibles.push({
          name: fechaini.format('YYYY'),
          check: false,
        });        
        fechaini.add(1, "years");
      }
      this.desactivado = false;

      const today = moment().format('YYYY');

      const ex = this.aniosDisponibles.find(an => an.name === today);
      if(ex){
        ex.check = true;
        this.setYear(Number(ex.name))
        this.meses = this.getMesesConDias(Number(ex.name));
      }else{
        this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
        this.setYear(Number(this.aniosDisponibles[this.aniosDisponibles.length-1].name))
        this.meses = this.getMesesConDias(Number(this.aniosDisponibles[this.aniosDisponibles.length-1].name));
      }
      const res2 = await firstValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
      for(const are of res2){
        if(Number(are.institution.id) === Number(plan.institution.id)){
          for(const res of are.responsibles){
            this.responsables.push({
              nombre: res.position,
              id: res.id,
              check: true,
              institucion: are.institution.name,
            });
          }
        }
      }
      this.responsables = this.ordenamientoAlf(this.responsables);
      await this.perPers(plan);
      this.perspectivas =  this.ordenamientoPer(this.perspectivas);
      this.objetivos = this.ordenamientoPer(this.objetivos);
      this.estrategias = this.ordenamientoPer(this.estrategias);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /** Metodos de ordenamiento */
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlf(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAdi(array: any){
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  
  /** Clasificación de los datos */
  //Obtención de las perspectivas
  private async perPers(plan: any){
    var aux = [], aux2 = [], strat = [], proyects = [];
    for(const per of plan.perspectives){  
      aux.push({
        nombre: per.name,
        descripcion: per.descripcion,
        planningId: plan.id,
        id: per.id,
        check: true,
      });
    }
    var objetivos = [];
    for(const per of aux){
      const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
      objetivos = objetivos.concat(res);
      per['objectives'] = res;
    }
    for(const obj of objetivos){
      strat = strat.concat(obj.strategies.map(s => {return s.id}))
      proyects = proyects.concat(obj.projects.map(s => {return s.id}))
      aux2.push({
        nombre: obj.name,
        descripcion: obj.description, 
        ponderacion: obj.weighing,
        perspectiveId: obj.perspective.id,
        perspectiva: aux.find(p => p.id === obj.perspective.id), 
        id: obj.id
      })
    }
    this.perspectivas = [];
    this.objetivos = [];
    this.perspectivas = aux;
    this.objetivos = aux2;

    strat = [...new Set(strat)];
    const strategies = [];
    for (let i = 0; i < strat.length; i += 10) {
      const batch = strat.slice(i, i + 10);
      const results = await this.strategiaService.getStrategyGQL(batch);
      strategies.push(...results);
    }

    proyects = [...new Set(proyects)];
    const projects = [];
    
    for (let i = 0; i < proyects.length; i += 10) {
      const batch = proyects.slice(i, i + 10);
      const results = await this.proyectosService.getProyectsGQL(batch);
      projects.push(...results);
    }

    this.perProyec(projects);
    
    this.estrategias = strategies.map(est => {
      return {
        name: est.name,
        description: est.description,
        objetiveId: est.objectives, 
        id: est.id
      }
    });
  }

  /** Obtención de los proyectos */
  public perProyec(array: any){
    var aux = [];
    this.actividades = [];
    this.checks = [];
    for(const pro of array){
      var objectiveid = [];
      for(const objid of pro.objectives){
        objectiveid.push(objid.id)
      }
      var estrategiaId: any = [];
      for(const estId of pro.strategies){
        estrategiaId.push(estId.id)
      }
      this.checks.push({check: false});

      const actividades = pro.activities.map( act => { 
        return {
          nombre: act.name,
          fecha_inicio: moment(act.initial_date.split('T')[0]),
          fecha_fin: moment(act.end_date.split('T')[0]), 
          projectId: pro.id, 
          responsableId: act.responsible.id,
          id: act.id,
          adicionales: this.ordenamientoAdi(act.additions),
          history: act.historic,
        }
      });
      this.actividades = this.actividades.concat(actividades);

      aux.push({
        nombre: pro.name,
        ponderacion: pro.weightingHistory,
        objetiveId: objectiveid, 
        programasId: estrategiaId,
        responsibleId: pro.responsible.id,
        id: pro.id,
        descripcion: pro.description,
        actividades: actividades,
        check: false,
      });
    }
    this.proyectosTot = [];
    this.proyectosTot = aux;
    this.actividades = this.ordenamientoPer(this.actividades);
    this.diccionarioAdicionales = this.actividades.length !== 0 ? this.actividades[0].adicionales: [];
    this.obtfechasProy();
    this.obtDataTabla('cam');
    this.mostabla = true;
    this.obtResponsableDinamico();
  }
  public async altaAdicionales(act, p){
    for(const ad of this.actividades[p].adicionales){
      const existe = act.adicionales.find(adic => adic.name === ad.name && adic.type === ad.type);
      if(!existe){
        var adic = new Adicionales();
        adic.nombre = ad.name;
        adic.tipo = ad.type;
        adic.actividadId = act.id;
        adic.nota = '';
        adic.archivos = '';
        adic.monto = 0;
        this.desactivado = true;
        try{
          await firstValueFrom(this.adicionalService.postAdicionales(adic));
        }catch(err){
          this.desactivado = false;
          let er = obtenerError.errorObt(err['error'].message);
          messages.errorMessageGraph(er)
        }
      }
    }
  }

  /** Obtención de las fechas de los proyectos */
  public obtfechasProy(){
    for(const pro of this.proyectosTot){
      pro.fecha_fin = undefined;
      pro.fecha_ini = undefined;
      for(const act of this.actividades){
        if(Number(pro.id) === Number(act.projectId)){
          if(pro.fecha_ini === undefined){
            pro.fecha_ini = act.fecha_inicio;
          }else{
            if(pro.fecha_ini > act.fecha_inicio){
              pro.fecha_ini = act.fecha_inicio;
            }
          }
          if(pro.fecha_fin === undefined){
            pro.fecha_fin = act.fecha_fin;
          }else{
            if(pro.fecha_fin < act.fecha_fin){
              pro.fecha_fin = act.fecha_fin;
            }
          }
        }
      }
    }
  }

  /** Obtención de la lista de responsables dinamicamente */
  private obtResponsableDinamico(){
    var aux = [], aux2 = [];
    for(const pro of this.proyectos){
      const res = this.responsables.filter(res => Number(res.id) === Number(pro.responsibleId));
      const existe = aux.filter(res => res.id === pro.responsibleId);
      if(existe.length === 0 && res.length !== 0){
        aux.push({
          nombre: res[0].nombre,
          name: res[0].nombre,
          id: res[0].id,
          check: true,
        });
      }
      for(const act of pro.actividades){
        const resAct = this.responsables.filter(res => Number(res.id) === Number(act.responsableId));
        const existeAct = aux2.filter(res => Number(res.id) === Number(act.responsableId));
        if(existeAct.length === 0 && resAct.length !== 0){
          aux2.push({
            nombre: resAct[0].nombre,
            name: resAct[0].nombre,
            id: resAct[0].id,
            check: true,
          });
        }
      }
    }
    this.responsables2 = this.ordenamientoAlf(aux);
    this.responsablesAct = this.ordenamientoAlf(aux2);
  }

  /** Obtención de la tabla con responsables */
  public mostrarConResponsables(pro: any){
    if(this.perSelect !== ''){
      if( this.responsableAct(pro) && this.existeAnio(pro) && this.pertenece_perspective(pro) && this.perteneceProg(pro) ){
        return this.pertenece(pro);
      }else{
        return false;
      }
    }else{
      if( this.responsableAct(pro) && this.existeAnio(pro) ){
        return this.pertenece(pro);
      }else{
        return false;
      }
    }
  }
  private async obtDataTabla(tipo: string){
    this.proyectos = [];
    for(const pro of this.proyectosTot){
      switch(tipo){
        case 'all':
          if( this.mostrarConResponsables(pro) ){
            pro.actividades = this.actividades.filter(a => Number(a.projectId) === Number(pro.id));
            this.proyectos.push({...pro});
          }
        break;
        case 'cam':
          if( this.mostrar(pro) ){
            pro.actividades = this.actividades.filter(a => Number(a.projectId) === Number(pro.id));
            this.proyectos.push({...pro});
          }
        break;
      }
    }
    
    var tot=0;
    this.proyectos.forEach(p => p++);
    if(tot === this.proyectos.length){
      this.expandirProg = true;
    }else if(tot === 0){
      this.expandirProg = false;
    }

    for(const pro of this.proyectos){
      if(pro.actividades.length === 0 && pro.ponderacion.length !== 0){
        for(const pon of pro.ponderacion){
          try{
            const res = await firstValueFrom(this.proyectosService.deleteHistoricoPeso(pro.id, pon.id)); 
          }catch(err){
            messages.errorMessageGraph(err);
          }
        }
        pro.ponderacion = [];
      }
    }
    
  }
  private updateProyectsMostrar(){
    for(const pro of this.proyectos){
      const project = this.proyectosTot.find(p => Number(p.id) === Number(pro.id));
      pro.fecha_fin = project.fecha_fin;
      pro.fecha_ini = project.fecha_ini;
    }
  }
  
  /** Metodos de desición para mostrar un proyecto */
  public mostrar(pro: any){
    if(this.perSelect !== ''){
      if( this.existeAnio(pro) && this.pertenece_perspective(pro) && this.perteneceProg(pro) ){
        return this.pertenece(pro);
      }else{
        return false;
      }
    }else{
      if( this.existeAnio(pro) ){
        return this.pertenece(pro);
      }else{
        return false;
      }
    }
  }
  private responsableAct(pro: any){
    for(const res of this.responsables2){
      if(res.id === pro.responsibleId && res.check){
        return true;
      }
    }
    return false;
  }
  private existeAnio(pro: any){
    if(pro.fecha_ini !== undefined && pro.fecha_ini !== undefined){
      var fecha_ini = moment(pro.fecha_ini).format('YYYY'), fecha_fin = moment(pro.fecha_fin).format('YYYY');
      for(const an of this.aniosDisponibles){
        if(an.check === true && (an.name == fecha_ini || an.name == fecha_fin || an.name > fecha_ini && an.name < fecha_fin) ) {
          return true;
        }
      }
      return false;
    }else{
      return true;
    }
  }
  private pertenece(pro: any){
    if(this.objSelect !== ''){
      for(const obj of pro.objetiveId){
        if((obj) === this.objSelect){
          return true;
        }
      }
      return false;
    }else{
      return true;
    }
  }
  private perteneceProg(pro: any){
    if(this.estSelect != ''){
      for(const obj of pro.programasId){
        if(obj === this.estSelect){
          return true;
        }
      }
      return false;
    }else{
      return true;
    }
  }
  private pertenece_perspective(pro: any){
    var obj = [];
    for(const obje of pro.objetiveId){
      const om = this.objetivos.filter(obb => obb.id === obje);
      obj = obj.concat(om);
    }
    const ex = obj.filter(obj => obj.perspectiveId === this.perSelect)
    if( ex.length !== 0 ){
      return true;
    }
    return false;
  }
  public programa_pertenece(ObjSel: any, pro: any){
    for(const obj of pro.objetiveId){
      if(obj.id === ObjSel){
        return true;
      }
    }
    return false;
  }

  existeEstrategia(obj){
    if(this.formPro.controls['inputEstrategia'].value === '')
      return true;
    const est = this.estrategias.find(e => e.id === this.formPro.controls['inputEstrategia'].value)
    if(est.objetiveId[0].id === obj.id)
      return true;
    return false;
  }

  /** Cambios en los filtros */
  public yearChange(anio: any) {
    this.aniosDisponibles.forEach(an => { 
      an.name === anio.name? an.check=true:an.check=false;
      an.name === anio.name? this.setYear(Number(anio.name)):'';
      an.name === anio.name? this.meses = this.getMesesConDias(Number(anio.name)):'';
    });

    this.obtDataTabla('cam');
    this.obtResponsableDinamico();
  }
  public cambioLider(lider?: any){
    if(lider !== 'consolidado'){
      this.responsables2.forEach(res =>{ res.nombre === lider.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsables2.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsables2.length){
        this.selecAll = true
      }else{
        this.selecAll = false;
      }
    }else{
      if(this.selecAll){
        this.responsables2.forEach(res =>{ res.check = false});
      }else{
        this.responsables2.forEach(res =>{ res.check = true});
      }
      this.selecAll = !this.selecAll
      
    }
    if( lider !== undefined || this.selecAll){
      this.obtDataTabla('all');
    }
  }
  public cambioLiderAct(lider?: any){
    if(lider != 'consolidado'){
      this.responsablesAct.forEach(res =>{ res.nombre === lider.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesAct.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesAct.length){
        this.selecAllAct = true
      }else{
        this.selecAllAct = false;
      }
    }else{
      if(this.selecAllAct){
        this.responsablesAct.forEach(res =>{ res.check = false});
      }else{
        this.responsablesAct.forEach(res =>{ res.check = true});
      }
      this.selecAllAct = !this.selecAllAct
    }
  }

  /** Existen los tres puntos */
  public tresPuntosVis(){
    var sel = 0;
    for(const res of this.responsables){
      if(res.check){
        sel++;
      }
    }
    if(sel <= 1)
      return false;
    return true;
  }

  /** Borrar filtros */
  public borrarFiltro(){
    document.body.style.cursor = 'wait';
    this.aniosDisponibles.forEach(an => an.check = false );
    const today = moment(this.fechaAct).format('YYYY');
    const ex = this.aniosDisponibles.find(an => an.name === today);
    if(ex){
      ex.check = true;
      this.setYear(Number(ex.name))
      this.meses = this.getMesesConDias(Number(ex.name));
    }else{
      this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
      this.setYear(Number(this.aniosDisponibles[this.aniosDisponibles.length-1].name))
      this.meses = this.getMesesConDias(Number(this.aniosDisponibles[this.aniosDisponibles.length-1].name));
    }
    
    
    this.responsables.forEach(res => res.check = true);
    this.responsablesAct.forEach(res => res.check = true);

    this.perSelect = '';
    this.objSelect = '';
    this.estSelect = '';

    this.ordenamiento = 'id';

    this.obtDataTabla('cam');
    this.obtResponsableDinamico();

    setTimeout(() => {
      document.body.style.cursor = 'default';        
    }, 2000 );
  }
  /** Filtros de los selects */
  public cambioPer(){
    this.objSelect = '';
    this.estSelect = '';
    this.obtDataTabla('cam');
    this.obtResponsableDinamico();
  }
  public cambioObj(){
    this.estSelect = '';
    this.obtDataTabla('cam');
    this.obtResponsableDinamico();
  }
  public cambioEstra(){
    this.obtDataTabla('cam');
    this.obtResponsableDinamico();
  }

  /** Tooltips */
  public obtTooltip(idMat: String): String {
    switch(idMat){
      case 'perspectiva':
        const per = this.perspectivas.find( dat => { return dat.id === this.perSelect })
        if(per){
          return per.nombre;
        }
      break;
      case 'objetivo':
        const obj = this.objetivos.find( dat => { return dat.id === this.objSelect })
        if(obj){
          return obj.nombre;
        }
      break;
      case 'estrategia':
        const est = this.estrategias.find( dat => { return dat.id === this.estSelect })
        if(est){
          return est.name;
        }
      break;
    }
    return '';
  }

  /** Validación de proyectos */
  public async validarPro(){
    
    var noPond = '', proyec = 0, pondT = 0, pondD = 0;
    let ponTot = 0;
    var años = [];

    this.aniosDisponibles.forEach(an => años.push(an.name));
    var anio = '';
    var selecciono = false;

    const result = await messages.select(
      this.translate.instant('gestion.formulacion.proy-estra.selecAnio'),
      años,
      this.translate
    );
    if (result) {
      anio = años[result];
      selecciono = true;
    }

    if(selecciono){
      for(const obj of this.objetivos){
        for(const pro of this.proyectosTot){
          if (Number(pro.objetiveId[0]) === Number(obj.id) && this.existeAnioValidacion(pro, anio)){
            pondD++;
            for(const pon of pro.ponderacion){
              if(pon.period.split('-')[0] === anio+'' && pon.weighing !== 0){
              ponTot = Number( ( ponTot + pon.weighing ).toFixed(2) );
                proyec++;
                pondT++;
              }
            }
          }
        }
        if(pondD !== pondT){
          noPond += this.formatearTexto(obj.nombre,undefined,this.translate.instant('swal.proSi'));
        }else if( (proyec != 0 && ponTot !== 100)){
          noPond += this.formatearTexto(obj.nombre, ponTot);
        }
        pondD = 0;
        pondT = 0;
        ponTot = 0;
        proyec = 0;
      }  
      if(noPond != ''){
        let title = this.translate.instant('swal.objNo');
        this.finalizacionValidacion(title, noPond);
      }else{
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.ponder'));
      }
    }
  }
  private existeAnioValidacion(pro: any, anio){
    if(pro.fecha_ini !== undefined && pro.fecha_ini !== undefined){
      var fecha_ini = pro.fecha_ini.format('YYYY'), fecha_fin = pro.fecha_fin.format('YYYY');
      if((Number(anio) >= fecha_ini && Number(anio) <= fecha_fin) ){
        return true;
      }
      return false;
    }else{
      return false;
    }
  }
  private finalizacionValidacion(title, texto){
    texto += '<br/><div style="text-aling: center;font-weight: 500;"></div>';
    Swal.fire({
      title: ''+title,
      html: ""+texto,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
    });
  }
  public responsableActOfAct(act: any){
    for(const res of this.responsablesAct){
      if(res.id === act.responsableId && res.check){
        return true;
      }
    }
    return false;
  }

  /** Ponderación automatica */
  public async ponderacionAutomatica(){
    this.desactivado = true;
    var an;
    for(const a of this.aniosDisponibles){
      if(a.check){
        an = a.name;
      }
    }
    let pondero = false;
    for(const obj of this.objetivos){
      const proy = this.proyectosTot.filter(pro => Number(pro.objetiveId[0]) === Number(obj.id) && pro.actividades.length !== 0 && this.existeAnio(pro) );
      if(proy.length !== 0){
        pondero = true;
        var ponder = Number((100/proy.length).toFixed(1));
        var ponderTot = Number((ponder*proy.length).toFixed(1))
        var i = 0;
        for(const p of proy){
          if(100 > ponderTot && i === proy.length-1){
            const decPer = Number((100 - ponderTot).toFixed(1));
            ponder += decPer;
          }else if(100 < ponderTot && i === proy.length-1){
            const decnPer = Number((ponderTot - 100).toFixed(1));
            ponder = Number((ponder - decnPer).toFixed(1));
          }
          try{
          const val = p.ponderacion.filter(pon => pon.period.split('-')[0] === an);
            if(p.ponderacion.length === 0 || val.length === 0){
                const res = await firstValueFrom(this.proyectosService.postHistoricoPeso(ponder, p.id, an)); 
                p.ponderacion.push({
                  id: res.id,
                  periodo: res.period.split('-')[0],
                  ponderacion: res.weighing
                });
            }else{
              const res2 = await firstValueFrom(this.proyectosService.patchHistoricoPeso({peso: ponder, anio: an}, p.id, val[0].id)); 
              val[0].weighing = ponder;
            }
          }catch(err){
            this.desactivado = false;
            messages.errorMessageGraph(err);
          }
          i++;
        }
      }
    }
    if(pondero){
      this.desactivado = false;
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }else{
      this.desactivado = false;
      messages.infoMessageGraph(this.translate.instant('swal.noProy'));
    }
  }

  /** Formateo de datos */
  private formatearTexto(texto: string, pond?: number, texto2?: string){
    var linea = '';
    if(pond !== undefined){
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+'</span><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt"> - </span> <span>'+ this.translate.instant('swal.ponTot') + pond+"%</span></div>"; 
    }else if(texto2 !== undefined){
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+'</span><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt"> - </span> <span>'+texto2+"</span></div>"; 
    }else{
      linea += '<div style="text-align: left;"><span style="color: #4E9AC7;font-weight: 500;font-size: 17pt">&#8226;</span> <span>'+texto+"</span></div>"
    }
    return linea;
  }
  public formatearnormal(num: any){
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  public formatearnormalDec(num: any){
    num = '' + num.toFixed(1);
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    if (splitRight === '.0')
      return  splitLeft;

    return  splitLeft + splitRight;
  }

  /** Botones de ordenamiento en tabla */
  public ordenamientoTabla(){
    switch(this.ordenamiento){
      case 'id':
        this.proyectos = this.ordenamientoAlf(this.proyectos);
        this.ordenamiento = 'asc';
      break;
      case 'asc':
        this.proyectos = this.ordenamientoAlfInv(this.proyectos);
        this.ordenamiento = 'des';
      break;
      case 'des':
        this.proyectos = this.ordenamientoPer(this.proyectos);
        this.ordenamiento = 'id';
      break;
    }
  }
  public ordenamientoTablaAct(){
    switch(this.ordenamiento){
      case 'id':
        this.proyectos = this.ordenamientoPer(this.proyectos);
      break;
      case 'asc':
        this.proyectos = this.ordenamientoAlf(this.proyectos);
      break;
      case 'des':
        this.proyectos = this.ordenamientoAlfInv(this.proyectos);
      break;
    }
  }
  private ordenamientoAlfInv(array: any){
    array.sort(function (a: any, b: any) {
      if ( a.nombre.toLowerCase() < b.nombre.toLowerCase() ) {
        return 1;
      }
      if ( a.nombre.toLowerCase() > b.nombre.toLowerCase() ) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }

  /** Mostrar o ocuoltar las actividades */
  public mosOculAll(){
    for(const pro of this.proyectos){
      if(this.expandirProg){
        pro.check = false;
      }else{
        pro.check = true;
      }
    }
    this.proyectos.forEach(p => p.check = !this.expandirProg);
    this.proyectosTot.forEach(p => p.check = !this.expandirProg);
    this.expandirProg = !this.expandirProg;
  }
  public mosOcul(i: any){
    const proyecto = this.proyectos[i];
    proyecto.check = !proyecto.check
    const proyectoOriginal = this.proyectosTot.find(
      pro => Number(pro.id) === Number(proyecto.id)
    );
    if (proyectoOriginal) {
      proyectoOriginal.check = proyecto.check;
    }
    var check = 0;
    for(const pro of this.proyectos){
      if(pro.check){
        check++;
      }
    }
    if(check === this.proyectos.length){
      this.expandirProg = true;
    }else if(check === 0){
      this.expandirProg = false;
    }
  }
  public mostrarAct(act){
    for(const an of this.aniosDisponibles){
      if(an.check && (act.fecha_inicio.isSameOrAfter(moment(an.name,'YYYY'),'year') || act.fecha_fin.isSameOrBefore(moment(an.name,'YYYY')) )){
        return true;
      }
    }
    return false;
  }

  /** Adicionales */
  public async guardarAdi(){
    var name = this.formAdi.controls['inputNameAdi'].value;
    var tipo = this.formAdi.controls['inputNameAdiEdit'].value;
    this.diccionarioAdicionales = [];
    this.adicionalesPost = 0;
    messages.messageSaving(this.translate.instant('swal.agreAdi'),this.translate.instant('swal.espere'));
    for(const act of this.actividades){
      var adic = new Adicionales();
      adic.nombre = name;
      adic.tipo = tipo;
      adic.actividadId = act.id;
      switch(tipo){
        case 'texto': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'moneda': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'numero': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'archivo': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
      }
      this.desactivado = true;
      try{
        const res = await firstValueFrom(this.adicionalService.postAdicionalesActiviti(adic));

        act.adicionales.push({
          ...res,
          files: [],
          comments: []
        });
      }catch(err){
        Swal.close();
        messages.errorMessageGraph(err)
      }
    }
    this.obtfechasProy();
    this.obtDataTabla('cam');
    this.obtResponsableDinamico();
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    this.diccionarioAdicionales = this.actividades[0].adicionales;
    this.desactivado = false;
    this.closeModal();
  }
  public async editarAdicional(adi: any){
    var guardo = false;
    var introdujo = await Swal.fire({
      title: 'Ingrese el nombre del adicional',
      text: "",
      input: 'text',
      inputValue: adi.name,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
          guardo = true;
          return '';
      }
    });

    if(guardo){
      this.desactivado = true;
      this.diccionarioAdicionales = [];
      var edit = 0;
      const name = adi.name;
      messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
      try{
        for(const act of this.actividades){
          const adEdit = act.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
          if(adEdit.length !== 0){
            adEdit[0].name = introdujo.value;
            try{
              const res = await firstValueFrom(this.adicionalService.patchAdicionalesNombre(adEdit[0]));
            }catch(err){
              let er = obtenerError.errorObt(err['error'].message);
              messages.errorMessageGraph(er);
            }
          }
        }
      }catch(err){
        this.desactivado = false;
        messages.errorMessageGraph(err);
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.desactivado = false;
      this.diccionarioAdicionales = this.actividades[0].adicionales;
    }else{
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  public async eliminarAdicional(adi: any){
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.formulacion.proy-estra.eliminarAdicional'),
      this.translate.instant('gestion.formulacion.proy-estra.eliminarAdicional2'),
      this.translate
    );

    if(result){
      this.desactivado = true;
      this.diccionarioAdicionales = [];
      const name = adi.name;
      messages.messageSaving(this.translate.instant('swal.eliminandoInfo'), this.translate.instant('swal.espere'));
      for(const ind of this.actividades){
        const adEdit = ind.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
        ind.adicionales = ind.adicionales.filter(ad => !(ad.name === name && ad.type === adi.type));
        try{
          if(adEdit.length !== 0){
            const res = await firstValueFrom(this.adicionalService.deleteAdicional(adEdit[0])); 
          }
        }catch(err){
          this.desactivado = false;
          messages.errorMessageGraph(err);
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.diccionarioAdicionales = this.actividades[0].adicionales;
    }
    this.desactivado = false;
  }
  // Metodos del modal
  public agregarAdicional(){
    this.titModal = this.translate.instant('gestion.formulacion.proy-estra.titModalColAdicional')
    this.modal3 = true;
  }
  // Adicionales valores editables
  public async editar(act: any, adicId: any){
    var inputValue: any, introdujo: any, guardo = false;
    switch(act.adicionales[adicId].type){
      case 'texto':
        inputValue = act.adicionales[adicId].note; 
      break;
      case 'moneda': 
        inputValue  = act.adicionales[adicId].amount; 
      break;
      case 'numero': 
        inputValue  = this.obtComment(act.adicionales[adicId].comments); 
      break;
      case 'archivo':
        inputValue  = act.adicionales[adicId].files; 
      break;
    }
    switch(act.adicionales[adicId].type){
      case 'moneda':introdujo = await Swal.fire({
        title: this.translate.instant('gestion.formulacion.proy-estra.ingresaValor'),
        text: "",
        input: 'number',
        inputValue: inputValue,
        showCancelButton: true,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('swal.acep'),
        cancelButtonText: this.translate.instant('swal.cerr'),
        reverseButtons: true,
        customClass: {
          actions: 'aleema-swal-actions',
          confirmButton: 'aleema-swal-confirm',
          cancelButton: 'aleema-swal-cancel',
          input: 'aleema-swal-select'
        },
        inputValidator: (value) => {
          if (!value) {
            return 'Ingeresa un dato valido';
          }
          guardo = true;
          return '';
        }
      });
    break;
      case 'numero':
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.formulacion.proy-estra.ingresaValor'),
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return 'Ingeresa un dato valido';
            }
            guardo = true;
            return '';
          }
        });
      break;
    }
    if(guardo){
      try{
        this.desactivado = true;
        switch(act.adicionales[adicId].type){
          case 'moneda':
            act.adicionales[adicId].amount = introdujo["value"];
            const res = await firstValueFrom(this.adicionalService.patchAdicionales(act.adicionales[adicId],act.id)); 
            // const res2 = await firstValueFrom(this.proyextosestrategicoService.getActividades()); 
            // this.perActivAct(res2);
            this.desactivado = false;
            messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
          break;
          case 'numero':
            act.adicionales[adicId].note = introdujo.value;
            var existe = false;
            var per =  Number(this.aniosDisponibles.filter(an => an.check)[0].name);
            for(const comen of act.adicionales[adicId].comments){
              var percom = Number(moment(comen.createdAt).format('YYYY'));
              if(per === percom){
                comen.comment = introdujo.value;
                existe = true;
                const res = await firstValueFrom(this.adicionalService.patchComment(comen, act.adicionales[adicId].id)); 
                this.desactivado = false;
              }
            }
            if(!existe){
              var date = new Date('1'+'-1-'+Number(this.aniosDisponibles.filter(an => an.check)[0].name));
              var aux = {
                comment: introdujo.value,
                createdAt: date.toISOString(),
                id: 0,
              }
              const res = await firstValueFrom(this.adicionalService.postComment(aux, act.adicionales[adicId].id)); 
              aux.id = res.id;
              act.adicionales[adicId].comments.push(aux);
              this.desactivado = false;
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          break;
        }
      }catch(err){
        this.desactivado = false;
        messages.errorMessageGraph(err);
      }
      
    }else {
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  // Edición de adicional
  public edicion(adicId: any, pro: any){
    if(pro.adicionales[adicId].type === 'moneda' || pro.adicionales[adicId].type === 'numero')
      return true;
    return false;
  }
  // Muestro de adicionales 
  public imprimir(act: any, adicId: any){
    switch(act.adicionales[adicId].type){
      case 'texto':
        return '';
      case 'moneda':
        return this.formatearnormal(act.adicionales[adicId].amount);
      case 'numero':
        return this.obtComment(act.adicionales[adicId].comments);
      case 'archivo':
        return '';
    }
    return '';
  }
  private obtComment(com : any){
    for(const comen of com){
      var per =  Number(this.aniosDisponibles.filter(an => an.check)[0].name);
      var percom = Number(moment(comen.createdAt.split('T')[0]).format('YYYY'));
      if(per === percom){
        return comen.comment;
      } 
    }
    return '';
  }

  /** Actividades */
  public async eliminar(act: any){
    this.desactivado = true;
    messages.messageSaving(this.translate.instant('swal.eliminandoInfo'), this.translate.instant('swal.espere'));
    try{
      const res = await firstValueFrom(this.actividadService.deleteActividades(act)); 
      const proyAdd = this.proyectosTot.find(p => Number(p.id) === Number(act.projectId));
      proyAdd.actividades = [].concat(proyAdd.actividades.filter(a => Number(a.id) !== Number(act.id)));
      const proyAddM = this.proyectos.find(p => Number(p.id) === Number(act.projectId));
      proyAddM.actividades = [].concat(proyAddM.actividades.filter(a => Number(a.id) !== Number(act.id)));
      this.actividades = [].concat(this.actividades.filter(a => Number(a.id) !== Number(act.id)));
      
      this.obtfechasProy();
      this.updateProyectsMostrar();
      this.obtResponsableDinamico();
      this.desactivado = false;
      messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public async guardarAct(accion){
    if(accion === 'agregar'){
      var actividad = new Actividades();
      actividad.nombre = this.formAct.controls['inputNameAct'].value;
      actividad.fecha_inicio = new Date(this.formAct.controls['inputFechaIn'].value);
      actividad.fecha_fin = new Date(this.formAct.controls['inputFechaFn'].value);
      actividad.projectId = this.proyectoId;
      actividad.responsibleId = Number(this.formAct.controls['inputLider'].value);
      messages.messageSaving(this.translate.instant('swal.agreAct'),this.translate.instant('swal.espere'))
      try{
        this.desactivado = true;
        const res = await firstValueFrom(this.actividadService.postActividades(actividad));
        const altaActividad = {
          nombre: res.name,
          fecha_inicio: moment(res.initial_date.split('T')[0]),
          fecha_fin: moment(res.end_date.split('T')[0]), 
          projectId: `${res.projectId}`, 
          responsableId: `${res.responsibleId}`,
          id: res.id,
          adicionales: [],
          history: [],
        }
        const actAlta = res;
        actividad.historico = Meses.obtenerPlaneado(actividad.fecha_inicio, actividad.fecha_fin, this.diasLab);
        if(this.actividades.length !== 0 && this.actividades[0].adicionales.length !== 0){
          for(const ad of this.actividades[0].adicionales){
            var adic = new Adicionales();
            adic.nombre = ad.name;
            adic.tipo = ad.type;
            adic.actividadId = Number(actAlta.id);
            adic.nota = '';
            adic.archivos = '';
            adic.monto = 0;
            const res2 = await firstValueFrom(this.adicionalService.postAdicionalesActiviti(adic)); 
            altaActividad.adicionales.push({
              ...res2,
              comments: [],
              files: []
            })
          }
          this.desactivado = false;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else{
          this.desactivado = false;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }
        const proyAdd = this.proyectosTot.find(p => Number(p.id) === Number(this.proyectoId));
        proyAdd.actividades.push(altaActividad);
        this.actividades.push(altaActividad);
        
        this.obtfechasProy();
        this.obtDataTabla('cam');
        this.obtResponsableDinamico();
        this.closeModal('modalAct');
      }catch(err){
        this.desactivado = false;
        messages.errorMessageGraph(err);
      } 
    }else if(accion === 'editar'){
      try{
        var text = '';
        if(this.actEdit.history.length !== 0 && this.comprobacionCambioFecha() && this.comprobacionInformacion(this.actEdit.history)){
          text = this.translate.instant('gestion.formulacion.proy-estra.borrarAvance');
          const result = await messages.confirmationSave(
            this.translate.instant('gestion.formulacion.proy-estra.guardarCambios'),
            this.translate.instant(''+text),
            this.translate
          );
          if (result) {
            this.guardarEditAct();
          }
        }else{
          this.guardarEditAct();
        }
        
      }catch(err){
        messages.errorMessageGraph(err);
      }
    }
  }
  public async guardarEditAct(){
    this.desactivado = true;
    try{
      if(this.actEdit.history.length !== 0 && this.comprobacionCambioFecha() ){
        for(const his of this.actEdit.history){
          const res = await firstValueFrom(this.actividadService.deleteHistory(this.actEdit, his)); 
        }
      }
      this.actEdit.nombre = this.formAct.controls['inputNameAct'].value;
      this.actEdit.fecha_inicio = new Date(this.formAct.controls['inputFechaIn'].value);
      this.actEdit.fecha_fin = new Date(this.formAct.controls['inputFechaFn'].value);
      this.actEdit.responsableId = this.formAct.controls['inputLider'].value;
      const res2 = await firstValueFrom(this.actividadService.patchActividades(this.actEdit));

      const proyAdd = this.proyectosTot.find(p => Number(p.id) === Number(this.proyectoId));
      const actProy = proyAdd.actividades.find( a => Number(a.id) === Number(this.actEdit.id));
      actProy.nombre = res2.name;
      actProy.fecha_inicio = moment(res2.initial_date.split('T')[0]);
      actProy.fecha_fin = moment(res2.end_date.split('T')[0]);
      actProy.responsibleId = `${res2.responsibleId}`;
      const act = this.actividades.find( a => Number(a.id) === Number(this.actEdit.id));
      act.nombre = res2.name;
      act.fecha_inicio = moment(res2.initial_date.split('T')[0]);
      act.fecha_fin = moment(res2.end_date.split('T')[0]);
      act.responsibleId = `${res2.responsibleId}`;

      this.obtfechasProy();
      this.obtDataTabla('cam');
      this.obtResponsableDinamico();
      this.desactivado = false;
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      this.desactivado = false;
      messages.errorMessageGraph(err);
    }    
    this.closeModal();
  }
    // metodos del modal
  public agragarActividades(idPro: any){
    this.proyectoId = idPro;
    this.accionModal = 'agregar';
    this.titModal = this.translate.instant('gestion.formulacion.proy-estra.titModalAgregarAct');

    this.modal2 = true;
  }
  public editActiv(actividad: any, idPro: any){
    this.actEdit = actividad;
    this.titModal = this.translate.instant('gestion.formulacion.proy-estra.titModalAgregarAct');
    this.accionModal = 'editar';
    this.proyectoId = idPro;
    this.formAct.controls['inputNameAct'].setValue(this.actEdit.nombre);
    this.formAct.controls['inputFechaIn'].setValue(this.actEdit.fecha_inicio.format('YYYY-MM-DD'));
    this.formAct.controls['inputFechaFn'].setValue(this.actEdit.fecha_fin.format('YYYY-MM-DD'));
    this.formAct.controls['inputLider'].setValue(this.actEdit.responsableId);
    this.modal2 = true;
  }

  /** Proyectos */
  public async alertas(aler: any, act?:any){
    var text = '';
    if(aler === 'eliminar'){
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.formulacion.proy-estra.eliminarAct'),
        this.translate.instant(''+act.nombre),
        this.translate
      );
      if (result) {
        this.eliminar(act);
      }
    }else if(aler === 'eliminarPro'){
      var activ = 0;
      for(const acti of this.actividades){
        if(Number(acti.projectId) === Number(act.id)){
          activ++;    
        }
      }
      if(activ != 0){
        text = this.translate.instant('gestion.formulacion.proy-estra.borrarActAsociadas')
      }

      const result = await messages.confirmationSave(
        this.translate.instant('gestion.formulacion.proy-estra.eliminarProy'),
        this.translate.instant(act.nombre+"<br>"+text),
        this.translate
      );
      if (result) {
        if(activ != 0){
          for(const acti of this.actividades){
            if(Number(acti.projectId) === Number(act.id)){
              try{
                const res = await firstValueFrom(this.actividadService.deleteActividades(acti)); 
              }catch(err){
                messages.errorMessageGraph(err);
              }
            }              
          }
        }
        this.eliminar_pro(act);
      }
    }
  }
  public async guardarPro(accion){
    if(accion === 'agregar'){
      var proyecto = new Proyectos();
      proyecto.nombre = this.formPro.controls['inputNamePro'].value;
      proyecto.description = this.formPro.controls['inputDescripcion'].value === '' ? ' ': this.formPro.controls['inputDescripcion'].value;
      proyecto.objetiveId = [];
      proyecto.programaId = [];
      proyecto.objetiveId = [Number(this.formPro.controls['inputObjetivo'].value)];
      if(this.formPro.controls['inputEstrategia'].value !== '' && this.formPro.controls['inputEstrategia'].value !== null){
        proyecto.programaId.push(Number(this.formPro.controls['inputEstrategia'].value));
      }
      proyecto.responsibleId = Number(this.formPro.controls['inputLider'].value);
      try{
        this.desactivado = true;
        const res = await firstValueFrom(this.proyectosService.postProyectos(proyecto));
        this.proyectosTot.push({
          nombre: proyecto.nombre,
          ponderacion: [],
          objetiveId: proyecto.objetiveId.map(e => `${e}`), 
          programasId: proyecto.programaId.map(e => `${e}`),
          responsibleId: `${proyecto.responsibleId}`,
          descripcion: proyecto.descripcion,
          actividades: [],
          check: false,
          id: res.id,
        });
        this.obtfechasProy();
        this.obtDataTabla('cam');
        this.obtResponsableDinamico();
        this.desactivado = false;
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      }catch(err){
        this.desactivado = false;
        messages.errorMessageGraph(err);
      }
      this.closeModal();
    }else if(accion === 'editar'){
      this.proEdit.nombre = this.formPro.controls['inputNamePro'].value;
      this.proEdit.descripcion = this.formPro.controls['inputDescripcion'].value;
      this.proEdit.ponderacion = 0;
      this.proEdit.programasId = [];
      if(this.formPro.controls['inputEstrategia'].value !== '' && this.formPro.controls['inputEstrategia'].value !== null){
        this.proEdit.programasId.push(Number(this.formPro.controls['inputEstrategia'].value));
      }
      this.proEdit.objetiveId = [];
      this.proEdit.objetiveId = [Number(this.formPro.controls['inputObjetivo'].value)];
      this.proEdit.responsibleId = this.formPro.controls['inputLider'].value;

      this.desactivado = true;
      try{
        const res = await firstValueFrom(this.proyectosService.patchProyectos(this.proEdit)); 
        const edPro = this.proyectosTot.find(p => Number(p.id) === Number(this.proEdit.id));
        edPro.nombre = this.proEdit.nombre;
        edPro.descripcion = this.proEdit.descripcion;
        edPro.ponderacion = this.proEdit.ponderacion;
        edPro.programasId = this.proEdit.programasId;
        edPro.objetiveId = this.proEdit.objetiveId;
        edPro.responsibleId = this.proEdit.responsibleId;

        this.obtfechasProy();
        this.obtDataTabla('cam');
        this.obtResponsableDinamico();
        this.desactivado = false;
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      }catch(err){
        this.desactivado = false;
        messages.errorMessageGraph(err);
      }
      this.closeModal('modalProy');
    }   
    
  }
  public async eliminar_pro(pro: any){
    this.desactivado = true;
    this.mostabla = false;
    try{
      const res = await firstValueFrom(this.proyectosService.deleteProyectos(pro)); 
      
      this.proyectosTot = [].concat(this.proyectosTot.filter(p => Number(pro.id) !== Number(p.id)))

      this.obtfechasProy();
      this.obtDataTabla('cam');
      this.obtResponsableDinamico();
      this.mostabla = true;
      this.desactivado = false;
      messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
    }catch(err){
      this.desactivado = false;     
      messages.errorMessageGraph(err);
    }
  }
    //Metodos de abertura
  public editarPro(pro: any){
    this.titModal = this.translate.instant('gestion.formulacion.proy-estra.titModalEditarProy')
    this.accionModal = 'editar';
    this.proEdit = pro;
    this.formPro.controls['inputNamePro'].setValue(pro.nombre);
    this.formPro.controls['inputDescripcion'].setValue(pro.descripcion);
    if(pro.programasId[0] !== undefined){
      this.formPro.controls['inputEstrategia'].setValue(pro.programasId[0]);
    }
    this.formPro.controls['inputObjetivo'].setValue(pro.objetiveId[0]);
    this.formPro.controls['inputLider'].setValue(pro.responsibleId);

    this.modal1 = true;
  }
  public openModalProy(){
    this.titModal = this.translate.instant('gestion.formulacion.proy-estra.agregarProy');
    this.accionModal = 'agregar';
    this.modal1 = true;
  }

  /** Adicional visual del proyecto */
  public imprimirPro(pro: any, idAd: any){
    var tot = 0;
    var tipo = '';
    for(const act of this.actividades){
      if(act.projectId === pro.id){
        switch(act.adicionales[idAd].type){
          case 'moneda':
            tipo = 'moneda';
            tot += Number(act.adicionales[idAd].amount)
          break;
        }
      }
    }
      return this.formatearnormal(tot);
  }

  /** Ponderaciones */
  public async edicionPond(pro: any){
    var inputValue = 0, introdujo: any, guardo = false, texto = '';
    const objPond = this.campoPon(pro);

    if(objPond === null){
      inputValue = 0;
    }else{
      inputValue = objPond.weighing; 
    }

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.formulacion.proy-estra.ingresePond'),
      text: ""+texto,
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translate.instant('gestion.formulacion.proy-estra.datoInvalido');
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      this.desactivado = true;
      const valor = Number(introdujo.value);
      try{
        if(objPond !== null){
          objPond.weighing = valor;
          const res = await firstValueFrom(this.proyectosService.patchHistoricoPeso({peso: valor, anio: objPond.period.split('-')[0]}, pro.id, objPond.id)); 
          this.desactivado = false;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else{
          const peso = Number(introdujo.value);
          const fecha = this.aniosDisponibles.filter(an => an.check);
          const res2 = await firstValueFrom(this.proyectosService.postHistoricoPeso(peso, pro.id,fecha[0].name+'')); 
          pro.ponderacion.push(res2);
          this.desactivado = false;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }
      }catch(err){
        this.desactivado = false;
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      }
      
    }
  }
  public escribirPond(pro: any){
    const an = this.aniosDisponibles.filter(an => an.check === true);
    for(const pon of pro.ponderacion){
      if(Number(pon.period.split('-')[0]) === Number(an[0].name)){
        return pon.weighing;
      }
    }
    return null;
  }
  public campoPon(pro: any){
    const an = this.aniosDisponibles.filter(an => an.check === true);
    for(const pon of pro.ponderacion){
      if(pon.period.split('-')[0] === an[0].name){
        return pon;
      }
    }
    return null;
  }

  /** Metodos de optención */
  public obtDias(ini: any, fin: any){
    if(ini != undefined && fin != undefined){
      var dias = fin.diff(ini,'days');
      dias -= fin.diff(ini,'weeks')*2;
      return dias;
    }
    return '';
  }
  public obtFecha(fecha: any){
    if(fecha !== undefined){
      return fecha.format('DD-MM-YYYY')
    }else{
      return '';
    }
  }
  public obtres(res: any){
    for(const re of this.responsables){
      if(re.id === res){
        return re.nombre;
      }
    }
    return '';
  }

  /** comprobación de la fecha */
  private comprobacionCambioFecha(){
    let fecIn = moment(this.formAct.controls['inputFechaIn'].value);
    let fecFn = moment(this.formAct.controls['inputFechaFn'].value);
    let fecInAct = moment(this.actEdit.fecha_inicio);
    let fecFnAct = moment(this.actEdit.fecha_fin);
    if(!fecIn.isSame(fecInAct, 'day')){
      return true;
    }
    if(!fecFn.isSame(fecFnAct, 'day')){
      return true;
    }
    return false
  }
  /** Metodo de decición de guardado */
  private comprobacionInformacion(historico){
    var tieneInfo = false;
    for(const his of historico){
      if(his.executed !== null){
        tieneInfo = true;
      }
    }
    return tieneInfo;
  }
  /** Decisión de edición de los adicionales */
  public edicionPro(actid: any, adicId: any, pro: any){
    var tieneAct = 0;
    var actId = 0, i = 0;
    for(const act of this.actividades){
      if(act.projectId === pro.id){
        tieneAct++;
        actId = i;
      }
      i++;
    }
    if(tieneAct != 0 && this.actividades[actId].adicionales[adicId].type !== undefined){
      if(this.actividades[actId].adicionales[adicId].type === 'moneda')
        return true;
    }
    return false;
  }

  /** Modales */
  public closeModal(modal?){
    this.modal1 = false;
    this.modal2 = false;
    this.modal3 = false;
    this.formPro.reset(this.formProRes);
    this.formAct.reset(this.formActRes);
    this.formAdi.reset(this.formAdiRes);
  }

  /** Duplicidad en los nombres */
  public nombreDuplicidadAdi() {
    var nombre = ""
    nombre = this.formAdi.controls['inputNameAdi'].value;
    if(this.actividades.length !== 0 && nombre !== ''){
      const existe = this.actividades[0].adicionales.find( element => {
        return ( procesamiento.procesamiento_Texto(element.name).toLowerCase() === nombre.toLowerCase() );
      });
      if(existe) return true;
    }          
    return false;
  }

  /** Exportación de excel */
  public exportar_excel(){
    let headers = [];
    let proyectos = [];
    let actividades = [];
    if (this.mostabla) {
      let mess = [];
      for(const m of this.meses){
        mess.push(m.name);
      }
      let actAdic = [];
      if(this.actividades.length > 0){
        for(const aa of this.actividades[0].adicionales!){
          actAdic.push(aa.name);
        }
      }
      headers.push([
        this.translate.instant('gestion.formulacion.proy-estra.titTab1'),
        this.translate.instant('gestion.formulacion.proy-estra.titTab2'),
        this.translate.instant('gestion.formulacion.proy-estra.titTab3'),
        this.translate.instant('gestion.formulacion.proy-estra.titTab4'),
        this.translate.instant('gestion.formulacion.proy-estra.titTab5'),
        this.translate.instant('gestion.formulacion.proy-estra.titTab6'),
        ...actAdic
      ]);

      for(let j = 0; j < this.proyectos.length; j++){
        if(this.pertenece(this.proyectos[j]) && this.existeAnio(this.proyectos[j]) && this.responsableAct(this.proyectos[j]) && this.perteneceProg(this.proyectos[j])){
          let adP = [];
          let acts = [];
          if (this.actividades.length > 0) {         
            for (let l = 0; l < this.actividades[0].adicionales?.length!; l++) {
              if (this.edicionPro(j, l, this.proyectos[j])) {
                adP.push(this.imprimirPro(this.proyectos[j], l));
              } else {
                adP.push('');
              }
            } 
          }

          proyectos.push([
            this.proyectos[j].nombre,
            this.obtres(this.proyectos[j].responsibleId),
            this.escribirPond(this.proyectos[j])!==null?this.formatearnormalDec(this.escribirPond(this.proyectos[j])):0,
            this.obtFecha(this.proyectos[j].fecha_ini),
            this.obtDias(this.proyectos[j].fecha_ini, this.proyectos[j].fecha_fin),
            this.obtFecha(this.proyectos[j].fecha_fin),
            ...adP
          ])
          let adAct = [];

          for(let i = 0; i < this.actividades.length; i++){
            let a = []
            if(this.proyectos[j].id === this.actividades[i].projectId){
              let aux = 0;
                  for(const act of this.actividades[i].adicionales!){
                    a.push(this.imprimir(this.actividades[i],aux) ?? '')
                    aux++;
                  }
                  adAct.push(a)
              acts.push([
                '   '.concat(this.actividades[i].nombre),
                this.obtres(this.actividades[i].responsibleId),
                '',
                this.obtFecha(this.actividades[i].fecha_inicio),
                this.obtDias(this.actividades[i].fecha_inicio, this.actividades[i].fecha_fin),
                this.obtFecha(this.actividades[i].fecha_fin),
                ...a
              ])
            }
          }
          actividades.push(acts);
        }
      }
      let filtros = []
      if(this.perSelect){
        filtros.push(['Perspectiva:',this.perspectivas[this.perSelect].nombre]);
      }
      if(this.objSelect){
        filtros.push(['Objetivo:',this.objetivos[this.objSelect].nombre]);
      }
      filtros.push(this.estSelect ? ['Estrategia:',this.estrategias[this.estSelect].name] : []);
      this.excelService.generateExcelProyectosEstrategicosFormulacion("Formulación: Proyectos Estratégicos", headers, proyectos, actividades,  filtros, "proyectos_estrategicos");
    }
  }

  /** Metodos y variables necesarias para el GANTT */
  private yearStart = new Date(new Date().getFullYear(), 0, 1);
  private yearDays  = 365;

  setYear(year: number): void {
    this.yearStart = new Date(year, 0, 1);
    const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    this.yearDays  = isLeap ? 366 : 365;
  }
  getBarLeft(fecha: moment.Moment | string): string {
    if (!fecha) return '0%';
    const start = moment.isMoment(fecha) ? fecha.toDate() : new Date(fecha);
    const days = (start.getTime() - this.yearStart.getTime()) / 86400000;
    return Math.max(0, (days / this.yearDays) * 100).toFixed(2) + '%';
  }
  getBarWidth(fechaIni: moment.Moment | string, fechaFin: moment.Moment | string): string {
    if (!fechaIni || !fechaFin) return '0%';
    const start = moment.isMoment(fechaIni) ? fechaIni.toDate() : new Date(fechaIni);
    const end   = moment.isMoment(fechaFin) ? fechaFin.toDate() : new Date(fechaFin);
    const days  = (end.getTime() - start.getTime()) / 86400000 + 1;
    return Math.max(0.5, (days / this.yearDays) * 100).toFixed(2) + '%';
  }
  getMesWidth(mes: any): string {
    return ((mes.value / this.yearDays) * 100).toFixed(3) + '%';
  }
  getMesesConDias(year: number) {
    return [
      { name: 'ene', value: 31 },
      { name: 'feb', value: new Date(year, 2, 0).getDate() }, // 28 o 29 según año bisiesto
      { name: 'mar', value: 31 },
      { name: 'abr', value: 30 },
      { name: 'may', value: 31 },
      { name: 'jun', value: 30 },
      { name: 'jul', value: 31 },
      { name: 'ago', value: 31 },
      { name: 'sep', value: 30 },
      { name: 'oct', value: 31 },
      { name: 'nov', value: 30 },
      { name: 'dic', value: 31 },
    ];
  }
}
